/* eslint-disable no-undef */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Modal } from 'react-bootstrap';
import Header from '../../containers/Header/Header';
import Footer from '../Footer';
import modalImage from '../../../../assets/images/pin-image.png';
import './MainLayout.sass';


class MainLayout extends Component {
  state = {
    leavePagePopUp: false,
    increase: false,
    clientY: '',
  };

  componentDidMount() {
    if (!sessionStorage.getItem('firstVisitModal')) {
      sessionStorage.setItem('firstVisitModal', '1');
    }
  }

  handleLeavePopUpClose = () => {
    this.setState({ leavePagePopUp: false });
    sessionStorage.setItem('firstVisitModal', '0');
  };

  handleLeavePopUpOpen =() => {
    this.setState({ leavePagePopUp: true });
  };

  leaveModalPopUp = () => {
    this.checkDecrease(window.event.clientY);
    if (this.props.selectedLocations.length > 0) {
      if (sessionStorage.getItem('firstVisitModal') === '1' && window.event.clientY < 10 && this.state.increase) {
        this.handleLeavePopUpOpen();
      }
    }
  };

  checkDecrease(clientY) {
    this.setState(prevState => ({
      clientY,
      increase: prevState.clientY > clientY,
    }));
  }

  render() {
    return (
      <div onMouseMove={this.leaveModalPopUp}>
        <Header />
        <div className="content-container">
          {this.props.children}
        </div>
        <Footer footerData={this.props.footerData} />
        {this.state.leavePagePopUp && (
          <Modal
            className="leave-modals"
            show={this.state.leavePagePopUp}
            onHide={this.handleLeavePopUpClose}
            backdrop="static"
          >
            <Modal.Header closeButton />
            <Modal.Body>
              <p className="leave-modal-header">{I18n.t('popup_message.leave_popup_title')}</p>
              <div className="modal-leave-content">
                <div className="content-text">
                  <p className="leave-modal-text">
                    {I18n.t('popup_message.leave_popup_text')}
                  </p>
                </div>
                <div className="image-wrapper">
                  <img src={modalImage} alt="modal-leave-pin" />
                </div>
              </div>
            </Modal.Body>
          </Modal>
        )}
      </div>
    );
  }
}

MainLayout.propTypes = {
  children: PropTypes.node,
  footerData: PropTypes.oneOfType([PropTypes.object]),
  selectedLocations: PropTypes.oneOfType([PropTypes.array]),
};

MainLayout.defaultProps = {
  children: null,
  footerData: {},
  selectedLocations: [],
};

export default MainLayout;
